// Spread onto any `<input>` / `<Form.Control>` that describes something *other than* the
// current user's own info (a contact record, a client-side lookup box, etc.) to stop the
// browser and major password managers from offering autofill. `autoComplete='off'` covers
// the browser's own history; the vendor-specific `data-*-ignore` attrs suppress 1Password,
// LastPass, and Bitwarden respectively.
export const NO_AUTOFILL_PROPS = {
  autoComplete: 'off',
  'data-1p-ignore': 'true',
  'data-lpignore': 'true',
  'data-bwignore': 'true'
};
